import angular, { ITemplateCacheService } from 'angular';
const module = angular.module('flowingly.runner.reportsv2', []);
module.run([
  '$templateCache',
  function ($templateCache: ITemplateCacheService) {
    $templateCache.put(
      'Client/runner.reportsv2/runner.reportsv2.tmpl.html',
      require('./runner.reportsv2.tmpl.html').default
    );
  }
]);
